// extracted by mini-css-extract-plugin
module.exports = {"slot-machine":"Slots_slot-machine__2APJM","slot":"Slots_slot__3IUCy","slot__reel":"Slots_slot__reel__3zdec"};